import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ArrowSendIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M17.5895 8.24111C18.0375 8.56411 18.1388 9.18912 17.8158 9.6371C17.4928 10.0851 16.8678 10.1864 16.4198 9.86338L17.5895 8.24111ZM12.0079 5.44946L11.4243 4.63745L12.0088 4.21728L12.5928 4.63832L12.0079 5.44946ZM7.57917 9.86425C7.13071 10.1866 6.50585 10.0844 6.18351 9.6359C5.86117 9.18744 5.96341 8.56258 6.41187 8.24024L7.57917 9.86425ZM16.4198 9.86338L11.4231 6.26059L12.5928 4.63832L17.5895 8.24111L16.4198 9.86338ZM12.5916 6.26146L7.57917 9.86425L6.41187 8.24024L11.4243 4.63745L12.5916 6.26146Z" fill={props.fill} />
			<path d="M11.0077 18.0768C11.0077 18.6291 11.4554 19.0768 12.0077 19.0768C12.56 19.0768 13.0077 18.6291 13.0077 18.0768H11.0077ZM11.0077 6.07081V18.0768H13.0077V6.07081H11.0077Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ArrowSendIcon fill={props.fill} />
		</div>
	);
}